import HelpText from "../json/HelpText.json";

export default function helpTextReducer(
  state = {
    helpText: HelpText,
  },
  action
) {
  switch (action.type) {
    default:
      return state;
  }
}
